import React from "react";

import { MANTRA_WEBSITE_URL } from "@/utils/constants";

export function RedirectToWebsite(): JSX.Element {
  window.location.replace(MANTRA_WEBSITE_URL);
  return <></>;
}
